
import FootNav from '../../components/FootNav.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


export default {
directives: {
TransferDom
},
components: {
FormPreview,
XHeader,
XButton,
Tabbar,
TabbarItem,
Flexbox,
FlexboxItem,
Cell,
Group,
Radio,
Icon,
Popup,
Checklist,
Swipeout, SwipeoutItem, SwipeoutButton,
XAddress,
XInput,
XSwitch,
XTextarea,
Actionsheet,
FootNav
},
data() {
return {
showQuickRemark: false,

limitNumber: 999,
action: 'add',

actionIndex: 0,
show1: false,
model1: '',

showAddressList: false,

showEditAddress: false,
iconWidth: 40,

showEmpty: '',

cartItemsList: [],

addressList: [],

addressData: [],


address: {},
formAddress: this.formAddressInitData(),
userRemark: '',
paymentList: [],
reasonForClosePayment: '',
choosePaymentMethod: [],

selectedAdonProduct: [],
addonProductPrice: 0,
redPackage: [],
addonProduct: [],
redPackType: [],
ship_fee_list: [],
remarkPreList: {
' 残障人士，请优先短信通知': '残障人士短信通知',
},
showMenus: false,
menus: [{
label: '个人中心',
value: 'uc'
}],
discountAmount: 0,
userInfo: {},
isAgent: false,
agentLeftAmount: 0,

ship_fee: 0,
shownTotalPrice: 0,
}
},
computed: {
cateTotalPrice: function () {
let res = 0;
for (let x in this.cartItemsList) {
res += this.cartItemsList[x].cateTotalPrice
}
let num = res - this.discountAmount;
return num.toFixed(2);
},
submitBtnText() {
if (this.paymentList.length === 0) {
return '暂停支付';
}









return '结算';
},
submitBtnDisabled() {
if (this.isAgent) {
return false;
} else if (this.choosePaymentMethod.length === 1 && this.choosePaymentMethod[0] === 'agent_pay') {
return false;
} else {
return this.shownTotalPrice <= 0 || this.paymentList.length === 0;
}
},
shipFeeText() {
return this.ship_fee + ' 元';
}
},

watch: {
/*体验装 偏远地区加收8元快递费*/
address(o) {
if (o.is_far === true) {
this.ship_fee = this.ship_fee_list['far'];
} else if (o.is_far === false) {
this.ship_fee = this.ship_fee_list['normal'];
}
},
choosePaymentMethod(o, n) {
if (o.length === 1 && o[0] === 'agent_pay') {
this.shownTotalPrice = 0;
} else {
this.shownTotalPrice = this.cateTotalPrice;
}
}
},
created: function () {
this.$nextTick(function () {
document.title = '下单支付'
this.$vux.loading.show({
text: '加载中'
});
const url = this.tianYiWebUrl + '/wechat/cart/ajaxGetCartView';
this.$http.get(url).then(res => {
if (res.data.code == 200) {

this.cartItemsList = res.data.data.cartItems

if (res.data.data.defaultAddress !== null) {
this.address = res.data.data.defaultAddress
}

this.isAgent = res.data.data.isAgent;


this.paymentList = res.data.data.paymentList.data
this.reasonForClosePayment = res.data.data.paymentList.message;
this.showEmpty = false;
this.$vux.loading.hide();

this.addonProduct = res.data.data.addon_product;

/*邮费*/
this.ship_fee_list = res.data.data.ship_fee_list;

/*红包*/
this.redPackage = res.data.data.redPackage;
if (this.redPackage.length > 0) {
this.redPackType = [this.redPackage[0]['key']]
}

this.userInfo = res.data.data.userInfo;
if (this.paymentList.length === 0 && this.reasonForClosePayment !== '') {
this.$vux.alert.show(this.reasonForClosePayment)
}

} else if (res.data.code === 404) {
this.showEmpty = true;
this.$vux.loading.hide()
} else {
this.$vux.loading.hide()
}
})
})
},
methods: {
changeDiscount(value, label) {
if (value.length > 0) {
this.discountAmount = this.redPackage[0]['amount']
} else {
this.discountAmount = 0
}
},
handleActionSheet(k, v) {
if (k === 'uc') {
this.$router.push('/uc/index')
}
},
addToUserRemark(val) {
if (val != 'cancel') {
this.userRemark += val
}
},

formAddressInitData() {
return {
name: '',
tel: '',
pcr: [],
street: '',
is_default: false
}
},

_checkPaymentMethod() {
if (this.choosePaymentMethod.length === 0) {
this.$vux.alert.show({
title: '请选择支付方式',
content: '下拉选择支付方式',
});
return false;
}
if (this.choosePaymentMethod[0] === 'balance') {
if (parseFloat(this.shownTotalPrice) > parseFloat(this.userInfo['balance'])) {
this.$vux.alert.show({
title: '余额不足',
content: '您的当前余额为' + this.userInfo['balance'] + '不足以支付',
});
return false;
}
}
return true;
},

_checkProduct() {
if (this.cartItemsList.length == 0) {
}
},
_checkAddress() {
if (Object.keys(this.address).length == 0) {
this.$vux.alert.show({
title: '请选择收货地址',
content: '请选择收货地址',
});
return false;
}
return true;
},
clickAddonProduct() {
let price = 0;
if (this.selectedAdonProduct.length > 0) {
this.selectedAdonProduct.forEach(item => {
this.addonProduct.list.forEach(aop => {
if (aop.key === item) {
price += aop.price;
}
})
})
}

if (price > 0) {
this.addonProductPrice = price;
} else {
this.addonProductPrice = 0;
}
},
doOrder() {
if (this._checkPaymentMethod() === false || this._checkAddress() === false) {
return;
}

let _self = this;









this.$vux.confirm.show({
title: '支付确认',
content: '点击确定将立即支付， 是否确认支付',
onConfirm() {
_self._post.call(_self)
}
});

},
_post() {
const url = this.tianYiWebUrl + '/wechat/order/placeOrder'
this.$http.post(url, {
addressId: this.address.id,
remark: this.userRemark,
paymentMethod: this.choosePaymentMethod[0],
redPackType: this.redPackType[0],
addonProduct:this.selectedAdonProduct
}).then(r => {
if (this.choosePaymentMethod[0] === 'wechat') {
let _self = this;
if (r.data.code === 200) {
let config = r.data.data.json;

/*微信支付*/
function onBridgeReady() {
WeixinJSBridge.invoke(
'getBrandWCPayRequest', config,
function (res) {
if (res.err_msg == "get_brand_wcpay_request:ok") {

_self.$vux.alert.show({
title: '恭喜，下单成功',
content: '我们将尽快安排发货',
onHide() {
_self.$router.push('/uc/order/paid')
}
})
} else {

let errSuffix = '';
if (res.err_desc !== undefined) {
errSuffix = ', (错误:' + res.err_desc + ')';
}
_self.$vux.alert.show({
title: '微信支付未完成',
content: '若下单成功，您可到订单中心重新支付' + errSuffix,
onHide() {
_self.$router.push('/uc/order/willPay')
}
})
}
}
);
}

if (typeof WeixinJSBridge == "undefined") {
if (document.addEventListener) {
document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
} else if (document.attachEvent) {
document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
}
} else {
onBridgeReady();
}
} else {
_self.$vux.alert.show({
title: '微信支付未完成',
content: r.data.message,
onHide() {
_self.$router.push('/uc/order/willPay')
}
})
}
} else {

let _self = this;
if (r.data.code === 200) {
this.$vux.alert.show({
title: '恭喜，下单成功',
content: '我们将尽快安排发货',
onHide() {
_self.$router.push('/uc/order/paid')
}
})
} else {
this.$vux.alert.show({
title: '糟糕，出了点问题',
content: r.data.message,
onHide() {
_self.$router.push('/uc/order/willPay')
}
})
}
}
})
},

goToCate(cateId) {
this.$router.push('/shop/cate/' + cateId)
},

handleAddressList() {
const url = this.tianYiWebUrl + '/wechat/address/ajaxLists'
this.$http.get(url).then(v => {
this.addressList = v.data;
this.showAddressList = true;
})
},

addAddress() {
this.action = 'add';

this.formAddress = this.formAddressInitData();
this.$vux.loading.show({
text: '区域信息加载中'
});
const url = this.tianYiWebUrl + '/wechat/address/ajaxGetChinaCity';
this.$http.get(url).then(r => {
this.addressData = r.data;
this.showEditAddress = true;
this.$vux.loading.hide()
})
},
postAddress() {
if (
this.formAddress['name'] === '' ||
this.formAddress['pcr'] === [] ||
this.formAddress['pcr'].length < 3 ||
this.formAddress['street'] === '' ||
this.formAddress['tel'] === ''
) {
this.$vux.toast.show({text: '所有内容必须正确填写', type: 'cancel'});
return;
}
const url = this.tianYiWebUrl + '/wechat/address/ajaxPostAddress';
this.$http.post(url, this.formAddress).then(r => {
if (r.data.code === 200) {
if (this.action === 'add') {
this.addressList = [...this.addressList, r.data.data]
this.formAddress = this.formAddressInitData();
}
if (this.action === 'edit') {
this.addressList[this.actionIndex] = r.data.data
}
this.showEditAddress = false
}
})
},

onButtonClick(action, item, index) {
if (action === 'edit') {
this.$vux.loading.show({
text: '加载中'
});
this.action = 'edit'
this.actionIndex = index
const url = this.tianYiWebUrl + '/wechat/address/ajaxGetChinaCity';
this.$http.get(url).then(r => {
this.addressData = r.data;
this.formAddress = item;
this.formAddress['pcr'] = [item['provence_id'] + '', item['city_id'] + '', item['region_id'] + ''];
this.$vux.loading.hide();
this.showEditAddress = true
});
}
if (action === 'delete') {
var _self = this;
this.$vux.confirm.show({
title: '是否删除此地址',
onShow() {
},
onHide() {
},
onCancel() {
},
onConfirm() {

_self.$vux.loading.show({
text: '处理中'
});

const url = _self.tianYiWebUrl + '/wechat/address/ajaxDeleteAddress';
_self.$http.post(url, {id: item['id']}).then(r => {
_self.addressList.splice(index, 1)
_self.$vux.loading.hide();
})
}
});
}
},
chooseAddress(item) {
this.address = item
this.showAddressList = false
}
}
}



// WEBPACK FOOTER //
// ./src/components/cart/Index.vue